import defaultState from "./state";


const InboxSolicitudesReducer = (state = defaultState, action) => {
  switch (action.type) {

    case "LOADING_SOLICITUDES_EMPRESA_INBOX": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "SET_SOLICITUDES_CONFIRMAR_INBOX": {
      return Object.assign({}, state, {
        listaSolicitudes: action.listaSolicitudes,
        totalSolicitudes: action.total,
        filtrosSolicitudes: action.filtros,
      });
    }

    case "SET_SOLICITUDES_EMPRESA_FILTRADA_INBOX": {
      let array = [...action.listaSolicitudesFiltrada];
      return Object.assign({}, state, {
        listaSolicitudesFiltrada: array,
      });
    }

    case "SET_SOLICITUDES_EMPRESA_FILTRADA_TOTAL_INBOX": {
      return Object.assign({}, state, {
        totalSolicitudes: action.total,
      });
    }

    case "SET_SOLICITUDES_EMPRESA_FILTRADA_FILTROS_INBOX": {
      return Object.assign({}, state, {
        filtrosSolicitudes: action.filtros,
      });
    }

    case "OPEN_CLOSE_MODAL_AGENDAR_INBOX": {
      return Object.assign({}, state, {
        isOpenModalAgendar: action.isOpen,
      });
    }
    case "SET_SHOW_GESTION_SOLICITUD_INBOX": {
      return Object.assign({}, state, {
        gestionarSolicitudStatus: action.open
      })
    }
    case "SET_SELECTED_SOLICITUD_INBOX": {
      return Object.assign({}, state, {
        selectedSolicitud: action.data,
      })
    }

    case "SET_SELECTED_SOLICITUD_SHOW_INBOX": {
      return Object.assign({}, state, {
        selectedSolicitudShow: action.data,
      })
    }
    case "SET_NEW_SELECTED_SOLICITUD_INBOX": {
      return Object.assign({}, state, {
        selectedSolicitud: action.data,
      })
    }

    case "SET_WORKER_SELECTED_INBOX": {
      return Object.assign({}, state,{
        dataSelected: action.id
      })
    }
    case "SET_TIPO_SOLICITUD_INBOX": {
      return Object.assign({}, state, {
        selectedTipoSolicitud: action.tipo,
      });
    }

    case "SET_GRID_CUPOS_INBOX" : {
      return Object.assign({}, state, {
        dataGridCupos: action.data.dataGridCupos,
        hourRange: action.data.hourRange
      })
    }

    case "SET_REFRESH_SCHEDULING_INBOX": {
      return Object.assign({}, state, {
        dataGridCupos: action.data.dataGridCupos,
        selectedSolicitud: action.data.selectedSolicitud
      })
    }

    case "SET_CONNECTION_HUB": {
      return Object.assign({}, state, {
        connectionHub: action.connection 
      })
    }

    case "SET_SCHEDULING_DATA": {
      return Object.assign({}, state, {
        schedulingData: action.data 
      })
    }

    case "SET_LISTA_CARGOS": {
      return Object.assign({}, state, {
        listaCargos: action.data 
      })
    }

    case "SET_DATING_HORIZON": {
      return Object.assign({}, state, {
        listaHorizonteCitas: action.data 
      })
    }

    case "SET_CLEAN_INBOX": {
      return Object.assign({}, state, {
        listaSolicitudes: [],
        totalSolicitudes: null,
        filtrosSolicitudes: null,
        isOpenModalAgendar: false,
        gestionarSolicitudStatus: false,
        selectedSolicitud: null,
        selectedSolicitudShow: null,
        dataSelected: null,
        selectedTipoSolicitud: {
          Icon: "2", name: "Pendiente de agendamiento", column: "estadoSolicitud", value: { text: "aprobado", value: [2,5, 10] }  
        },
      });
    }
    default:
      return state;
  }
};


export default InboxSolicitudesReducer;
